<template>
    <div style="margin-top:30px">
        <div v-if="needsSign.length" class="needs-sign">
            <h3 class="needs-sign-title">Needs your signature<span class="needs-sign-count">{{ needsSign.length }}</span></h3>
            <div class="needs-sign-sub">Review and sign these processes — your signature is due.</div>
            <div class="needs-sign-list">
                <div v-for="(n, i) in needsSign" :key="i" class="home-process" @click="$router.push('/playbook/' + n.Slug)">
                    <!-- Tabler "signature" icon, as in the prototype (ironbook-proto.html .sign-ic) -->
                    <div class="home-process-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2" /></svg></div>
                    <div class="home-process-info">
                        <div class="home-process-name">{{ n.Name }}</div>
                        <div class="home-process-meta"><span v-if="n.HasPrevSignOff">Updated — please re-sign</span><span v-else>New — please sign</span></div>
                    </div>
                    <button type="button" class="btn home-process-sign" @click.stop="$router.push('/playbook/' + n.Slug)">Sign</button>
                </div>
            </div>
        </div>
        <div v-else-if="updated.length" class="needs-sign">
            <h3 class="needs-sign-title">Recently updated<span class="needs-sign-count">{{ updated.length }}</span></h3>
            <div class="needs-sign-sub">The latest changes</div>
            <div class="needs-sign-list">
                <div v-for="(n, i) in updated" :key="i" class="home-process" @click="$router.push('/playbook/' + n.Slug)">
                    <!-- Tabler "history" icon: a clock with an arrow winding back, for a recent change -->
                    <div class="home-process-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8v4l2 2" /><path d="M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" /></svg></div>
                    <div class="home-process-info">
                        <div class="home-process-name">{{ n.Name }}</div>
                        <div class="home-process-meta">Updated — {{ n.LastModifiedString }}</div>
                    </div>
                    <button type="button" class="btn home-process-sign" @click.stop="$router.push('/playbook/' + n.Slug)">Open</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
// import SvgIcon from './SvgIcon.vue';

export default defineComponent({
    name: 'NodesHomeNode',
    props: [  ],
    components: {
        // SvgIcon
    },
    data() {
        return {
            needsSign: [] as any,
            updated: [] as any
        }
    },
    async created() {
        while(!this.$store.state.allNodesLoaded) {
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        const nowTS = new Date().getTime();
        // 1 week
        const newMS = (86400000 * 7);
        const allNodes = JSON.parse(JSON.stringify(this.$store.state.allNodes));
        for(const n of allNodes) {
            const lastModified = new Date(n.LastModified);
            n.LastModifiedString = lastModified.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
            if(nowTS - lastModified.getTime() < newMS) {
                n.NewThisWeek = true;
            }
        }
        allNodes.sort((a: any, b: any) => {
            const aTS = new Date(a.LastModified).getTime();
            const bTS = new Date(b.LastModified).getTime();
            if(aTS > bTS) {
                return -1;
            } else if(aTS < bTS) {
                return 1;
            }
            return 0;
        })

        if(this.$store.state.user.isAdmin) {
            this.updated = allNodes.filter((n: any) => {
                return n.NewThisWeek;
            })
        } else {
            await axios.get(`${this.$store.state.apiUrl}/api/signoffs/minepublicuser`)
                .then(resp => {
                    for(const sig of resp.data){
                        const process = allNodes.find((p: any) => {
                            return p.Slug == sig.Slug;
                        });
                        if(process && !process.HasPrevSignOff) {
                            process.HasPrevSignOff = true;
                        }
                        if(process && !process.HasSignOff) {
                            if(new Date(sig.Date).getTime() > new Date(process.LastModified).getTime()) {
                                process.HasSignOff = true;
                                process.SignOffDate = new Date(sig.Date).toLocaleDateString();
                            }
                        }
                    }
                })
                .catch(e => {
                    console.log(e);
                })

            this.needsSign = allNodes.filter((n: any) => {
                return !n.HasSignOff;
            })
        }
    },
    methods: {
        
    }
});
</script>